import axiosInstance from "../axios/axios-instance";
import { pathAPI } from "../utils/pathApi";

export interface ProfileChange {
  field: string;
  label: string;
  old_value: string;
  new_value: string;
}

export interface AdminNotification {
  id: number;
  type: string;
  title: string;
  body: string;
  outletId?: number;
  data: {
    outlet_id?: number;
    outlet_name?: string;
    owner_name?: string;
    awaiting_review?: boolean;
    changes?: ProfileChange[];
  };
  read: boolean;
  createdDate: string;
}

// Server wraps responses as {success, data}; paged lists are flat {data: [], total}.
const unwrap = (response: any) => response?.data?.data ?? response?.data;

export const NotificationService = {
  list: async (page = 0, size = 20, unread = false) => {
    const response = await axiosInstance.get(pathAPI.notifications, {
      params: { page, size, unread },
    });
    return {
      items: (response?.data?.data ?? []) as AdminNotification[],
      total: (response?.data?.total ?? 0) as number,
    };
  },

  unreadCount: async (): Promise<number> => {
    const response = await axiosInstance.get(`${pathAPI.notifications}/unread-count`);
    return Number(unwrap(response)?.count ?? 0);
  },

  markRead: (id: number) => axiosInstance.post(`${pathAPI.notifications}/${id}/read`),

  markAllRead: () => axiosInstance.post(`${pathAPI.notifications}/read-all`),
};
